import { render, staticRenderFns } from "./Observador.vue?vue&type=template&id=64aba51c&"
import script from "./Observador.vue?vue&type=script&lang=js&"
export * from "./Observador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports